export function Footer() {
  return (
    <footer className="border-t py-4 mt-auto">
      <p className="text-center text-xs text-muted-foreground">
        miqat.io
      </p>
    </footer>
  );
}
